import { useState } from "react";
import {
    Container,
    Grid,
    AppBar,
    Tabs,
    Tab,
    Box,
} from "@material-ui/core";
import HomePage from "../../Home"
import PieChartIcon from '@material-ui/icons/PieChart'
import CotizacionesMes from "./CotizacionesMes"
import CotizacionesDia from "./CotizacionesDia"
import CotizacionesAgente from "./CotizacionesAgenteDia";
import CotizacionesAgenteMes from "./CotizacionesAgenteMes";
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    )
}
function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    }
}
const Cotizaciones = () => {
    const [value, setValue] = useState(0)
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    return (
        <Grid container>
            <Grid item xs={12}>
                <AppBar position="static" color="inherit">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="fullWidth"
                        scrollButtons="on"
                        indicatorColor="secondary"
                        aria-label="scrollable force tabs example"
                    >
                        <Tab
                            label="General Mes"
                            icon={<PieChartIcon />}
                            {...a11yProps(0)}
                        />
                        <Tab
                            label="General Día"
                            icon={<PieChartIcon />}
                            {...a11yProps(1)}
                        />
                        <Tab
                            label="Agente Mes"
                            icon={<PieChartIcon />}
                            {...a11yProps(2)}
                        />
                        <Tab
                            label="Agente Día"
                            icon={<PieChartIcon />}
                            {...a11yProps(3)}
                        />
                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0}>
                    <CotizacionesMes />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <CotizacionesDia />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <CotizacionesAgenteMes />
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <CotizacionesAgente />
                </TabPanel>
            </Grid>
        </Grid>
    )
}
export default Cotizaciones
